import { useQuery } from '@tanstack/react-query';
import { GET_FOLLOW_UP, lawyerDirectoryService } from '@/api';
import { SelectedAnswer } from '@/components/screens/lawyerapp/cases/case-clients/filters/document-filter-follow-up/DocumentFilterPanel';
import { useFilters } from '../useFilters';

export const useFollowUpFilter = (caseId: string | undefined) => {
	const { setParamFilter } = useFilters();

	const { data: followUpsList, isLoading } = useQuery({
		queryKey: [GET_FOLLOW_UP, caseId],
		queryFn: () => lawyerDirectoryService.getFollowUps(caseId as string),
		enabled: !!caseId,
	});

	const list = followUpsList?.data ?? [];
	const hasItems = list.length > 0;

	const applyFilter = (selectedAnswers: SelectedAnswer[]) => {
		const grouped = selectedAnswers.reduce<Record<number, string[]>>(
			(acc, sel) => {
				if (!acc[sel.questionId]) acc[sel.questionId] = [];
				acc[sel.questionId].push(sel.answerId);
				return acc;
			},
			{}
		);

		const questions = Object.entries(grouped).map(([questionId, answers]) => ({
			questionId: Number(questionId),
			answers,
		}));

		setParamFilter(
			'documentFilter',
			questions.length > 0 ? JSON.stringify(questions) : undefined
		);
	};

	return { list, isLoading, hasItems, applyFilter };
};
